module.exports = __webpack_public_path__ + "img/client-logo-6.2c454c14.png";